export const calculateScrollFromMousePosition = (
    clientX: number,
    rect: DOMRect,
    maxScrollLeft: number,
): number => {
    const x = clientX - rect.left - 0;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    return (percentage / 100) * maxScrollLeft;
};
